
<p-dms-treeview-entry
    :entry = "folder"
>
    <template v-slot:icon>
        <v-icon
            size  = "21"
            color = "primary"
        >
            {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
        </v-icon>
    </template>
</p-dms-treeview-entry>
